import { useDeleteFace } from '@vlabs/api/artemy/client';
import { DeleteIcon } from '@vlabs/icons';
import { Button } from '@vlabs/uikit/components/controls/button/Button';
import type { WithDataTestid } from '@vlabs/uikit/types';
import { useTranslation } from 'react-i18next';

import { confirmDeleteFace } from './ui/confirmDeleteFace';

interface DeleteFaceButtonPoint3Props extends WithDataTestid {
  faceId: string;
  onSuccess?: VoidFunction;
}

export function DeleteFaceButtonPoint3({
  faceId,
  onSuccess = undefined,
  'data-testid': dataTestId = 'deleteFaceButton',
  ...buttonProps
}: DeleteFaceButtonPoint3Props): React.JSX.Element {
  const { t } = useTranslation();
  const deleteFaceMutation = useDeleteFace();

  const handleDelete = (e?: React.MouseEvent<HTMLElement>) => {
    e?.stopPropagation();
    const onConfirm = async () => {
      await deleteFaceMutation.mutateAsync({ faceId });
      onSuccess?.();
    };
    confirmDeleteFace({ onConfirm });
  };

  return (
    <Button
      data-testid={dataTestId}
      icon={<DeleteIcon />}
      kind="negative"
      onClick={handleDelete}
      size="small"
      variant="flat"
      {...buttonProps}
    >
      {t('features:deleteFace.btn.delete_face')}
    </Button>
  );
}
